export default __webpack_public_path__ + "static/media/imagem-modal-esqueci-a-senha.97b41db4.png";